import { render } from "./JsonViewer.vue?vue&type=template&id=80bfa92c&scoped=true"
import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"

import "./JsonViewer.vue?vue&type=style&index=0&id=80bfa92c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80bfa92c"]])

export default __exports__